import React from "react";

// Native details/summary: answers stay in the HTML so Google can read them.
export default function FaqAccordion({ items, testidPrefix = "faq", openFirst = true, children }) {
  return (
    <div className="faq-list">
      {items.map((it, i) => (
        <details key={it.q} open={openFirst && i === 0} data-testid={`${testidPrefix}-item-${i}`}>
          <summary>
            {it.q}
            <span className="pm" aria-hidden="true">+</span>
          </summary>
          <p>{it.a}</p>
        </details>
      ))}
      {children}
    </div>
  );
}
